export default __webpack_public_path__ + "static/media/grt.b056d5f3.svg";